import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=7553e6dc&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=7553e6dc&prod&lang=scss"
import style1 from "./product-detail.vue?vue&type=style&index=1&id=7553e6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7553e6dc",
  null
  
)

export default component.exports